// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wq_a bib_b","TwoDimsListFeature__item":"wq_b bib_we","TwoDimsListFeature__item__text":"wq_c bib_vt"};